(function () {
  var sections = document.querySelectorAll('[data-cd-pdp-product-images]');
  if (!sections.length) return;

  function splitRenderedLines(node, text) {
    var words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return text ? [text] : [];

    var nodeWidth = Math.round(node.getBoundingClientRect().width || node.offsetWidth || 0);
    if (nodeWidth <= 2) return [text];

    var measure = document.createElement(node.tagName || 'span');
    var computed = window.getComputedStyle(node);

    measure.style.position = 'absolute';
    measure.style.left = '-99999px';
    measure.style.top = '0';
    measure.style.visibility = 'hidden';
    measure.style.pointerEvents = 'none';
    measure.style.width = nodeWidth + 'px';
    measure.style.maxWidth = 'none';
    measure.style.whiteSpace = 'normal';
    measure.style.font = computed.font;
    measure.style.fontFamily = computed.fontFamily;
    measure.style.fontSize = computed.fontSize;
    measure.style.fontWeight = computed.fontWeight;
    measure.style.letterSpacing = computed.letterSpacing;
    measure.style.lineHeight = computed.lineHeight;
    measure.style.textTransform = computed.textTransform;
    measure.style.textAlign = computed.textAlign;

    document.body.appendChild(measure);

    var spans = words.map(function (word, index) {
      var span = document.createElement('span');
      span.textContent = index === words.length - 1 ? word : word + ' ';
      span.style.display = 'inline-block';
      span.style.whiteSpace = 'pre';
      measure.appendChild(span);
      return span;
    });

    var lines = [];
    var current = [];
    var currentTop = null;

    spans.forEach(function (span) {
      var top = span.offsetTop;
      if (currentTop === null) currentTop = top;
      if (Math.abs(top - currentTop) > 2 && current.length) {
        lines.push(current.join('').trim());
        current = [];
        currentTop = top;
      }
      current.push(span.textContent || '');
    });

    if (current.length) lines.push(current.join('').trim());
    measure.remove();
    return lines.length ? lines : [text];
  }

  function buildLineflow(node) {
    if (!node) return;

    if (!node.dataset.cdPdpOriginalHtml) {
      node.dataset.cdPdpOriginalHtml = node.innerHTML;
    }

    var raw = node.dataset.cdPdpOriginalHtml
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .trim();

    if (!raw) return;

    var segments = raw.split(/\n+/).map(function (segment) {
      return segment.replace(/\s+/g, ' ').trim();
    }).filter(Boolean);

    node.innerHTML = '';
    var lineIndex = 0;

    segments.forEach(function (segment) {
      splitRenderedLines(node, segment).forEach(function (line) {
        var lineEl = document.createElement('span');
        lineEl.className = 'cd-pdp-product-line';
        lineEl.style.setProperty('--cd-pdp-line-index', String(lineIndex));

        var textEl = document.createElement('span');
        textEl.className = 'cd-pdp-product-line__text';
        textEl.textContent = line;

        lineEl.appendChild(textEl);
        node.appendChild(lineEl);
        lineIndex += 1;
      });
    });
  }

  function setupGalleryProgress(section) {
    var rail = section.querySelector('[data-cd-pdp-gallery-rail]');
    var bar = section.querySelector('[data-cd-pdp-gallery-progress]');
    var progress = section.querySelector('[data-cd-pdp-gallery-scrollbar]') || (bar ? bar.parentElement : null);
    if (!rail || !bar || !progress) return;

    var isDragging = false;
    var dragOffset = 0;
    var railPointerId = null;
    var railDragActive = false;
    var railMoved = false;
    var railStartX = 0;
    var railStartY = 0;
    var railStartScrollLeft = 0;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getMaxScroll() {
      return Math.max(rail.scrollWidth - rail.clientWidth, 0);
    }

    function getThumbMetrics() {
      var trackWidth = Math.max(progress.clientWidth || progress.getBoundingClientRect().width || 0, 1);
      var visibleRatio = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
      var minThumb = window.matchMedia('(max-width: 749px)').matches ? 56 : 72;
      var thumbWidth = clamp(Math.round(trackWidth * visibleRatio), Math.min(minThumb, trackWidth), trackWidth);
      var maxMove = Math.max(trackWidth - thumbWidth, 0);

      return {
        trackWidth: trackWidth,
        thumbWidth: thumbWidth,
        maxMove: maxMove
      };
    }

    function update() {
      var max = getMaxScroll();
      var ratio = max > 0 ? rail.scrollLeft / max : 0;
      var metrics = getThumbMetrics();
      var left = ratio * metrics.maxMove;

      bar.style.width = metrics.thumbWidth + 'px';
      bar.style.transform = 'translate3d(' + left + 'px, 0, 0)';

      progress.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      progress.classList.toggle('is-scrollable', max > 1);
      section.classList.toggle('cd-pdp-product-images--has-horizontal-scroll', max > 1);
    }

    function scrollFromClientX(clientX) {
      var max = getMaxScroll();
      var metrics = getThumbMetrics();
      var rect = progress.getBoundingClientRect();
      var left = clamp(clientX - rect.left - dragOffset, 0, metrics.maxMove);
      var ratio = metrics.maxMove > 0 ? left / metrics.maxMove : 0;

      rail.scrollLeft = ratio * max;
      update();
    }

    progress.addEventListener('pointerdown', function (event) {
      if (getMaxScroll() <= 1) return;

      var barRect = bar.getBoundingClientRect();
      var pressedThumb = event.target === bar || bar.contains(event.target);
      dragOffset = pressedThumb ? event.clientX - barRect.left : barRect.width / 2;
      isDragging = true;
      progress.classList.add('is-dragging');

      if (progress.setPointerCapture) {
        try { progress.setPointerCapture(event.pointerId); } catch (error) {}
      }

      scrollFromClientX(event.clientX);
      event.preventDefault();
    });

    progress.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      scrollFromClientX(event.clientX);
      event.preventDefault();
    });

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      progress.classList.remove('is-dragging');

      if (progress.releasePointerCapture && event) {
        try { progress.releasePointerCapture(event.pointerId); } catch (error) {}
      }
    }

    progress.addEventListener('pointerup', endDrag);
    progress.addEventListener('pointercancel', endDrag);
    progress.addEventListener('lostpointercapture', function () {
      isDragging = false;
      progress.classList.remove('is-dragging');
    });

    progress.addEventListener('keydown', function (event) {
      var max = getMaxScroll();
      if (max <= 1) return;

      var step = Math.max(rail.clientWidth * 0.18, 80);
      var handled = true;

      if (event.key === 'ArrowRight') {
        rail.scrollLeft += step;
      } else if (event.key === 'ArrowLeft') {
        rail.scrollLeft -= step;
      } else if (event.key === 'PageDown') {
        rail.scrollLeft += rail.clientWidth * 0.85;
      } else if (event.key === 'PageUp') {
        rail.scrollLeft -= rail.clientWidth * 0.85;
      } else if (event.key === 'Home') {
        rail.scrollLeft = 0;
      } else if (event.key === 'End') {
        rail.scrollLeft = max;
      } else {
        handled = false;
      }

      if (handled) {
        event.preventDefault();
        update();
      }
    });

    function stopRailDrag(event) {
      if (!railDragActive) return;

      if (rail.releasePointerCapture && event && railPointerId !== null) {
        try { rail.releasePointerCapture(railPointerId); } catch (error) {}
      }

      railPointerId = null;
      railDragActive = false;
      window.setTimeout(function () {
        railMoved = false;
        rail.classList.remove('is-pointer-dragging');
      }, 0);
    }

    rail.addEventListener('pointerdown', function (event) {
      if (event.button !== 0 || getMaxScroll() <= 1) return;

      /* Touch already has native swipe. This fixes desktop mouse/trackpad cases where
         the hidden native scrollbar makes the carousel feel like it is not scrollable. */
      if (event.pointerType === 'touch') return;

      railPointerId = event.pointerId;
      railDragActive = true;
      railMoved = false;
      railStartX = event.clientX;
      railStartY = event.clientY;
      railStartScrollLeft = rail.scrollLeft;
      rail.classList.add('is-pointer-dragging');

      if (rail.setPointerCapture) {
        try { rail.setPointerCapture(event.pointerId); } catch (error) {}
      }
    });

    rail.addEventListener('pointermove', function (event) {
      if (!railDragActive || event.pointerId !== railPointerId) return;

      var deltaX = event.clientX - railStartX;
      var deltaY = event.clientY - railStartY;

      if (!railMoved && Math.abs(deltaX) < 4 && Math.abs(deltaY) < 4) return;

      railMoved = true;
      rail.scrollLeft = railStartScrollLeft - deltaX;
      update();
      event.preventDefault();
    }, { passive: false });

    rail.addEventListener('pointerup', stopRailDrag);
    rail.addEventListener('pointercancel', stopRailDrag);
    rail.addEventListener('lostpointercapture', stopRailDrag);

    rail.addEventListener('click', function (event) {
      if (!railMoved) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    rail.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    rail.addEventListener('wheel', function (event) {
      var max = getMaxScroll();
      if (max <= 1) return;

      var horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      var shiftScroll = event.shiftKey && Math.abs(event.deltaY) > 0;

      /* Do not hijack normal vertical mouse/trackpad scrolling. The rail should move
         by dragging, by a deliberate horizontal gesture, or by holding Shift while scrolling. */
      if (!horizontalIntent && !shiftScroll) return;

      var delta = horizontalIntent ? event.deltaX : event.deltaY;
      if (!delta) return;

      if (event.deltaMode === 1) {
        delta *= 16;
      } else if (event.deltaMode === 2) {
        delta *= rail.clientWidth;
      }

      var nextScrollLeft = clamp(rail.scrollLeft + delta, 0, max);
      var canMove = Math.abs(nextScrollLeft - rail.scrollLeft) > 0.5;

      /* Once the carousel reaches an edge, allow the page to scroll normally again. */
      if (!canMove) return;

      rail.scrollLeft = nextScrollLeft;
      update();
      event.preventDefault();
    }, { passive: false });

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function () {
        requestAnimationFrame(update);
      });
      resizeObserver.observe(rail);
      resizeObserver.observe(progress);
    }

    rail.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
      if (img.complete) return;
      img.addEventListener('load', update, { passive: true, once: true });
    });

    requestAnimationFrame(update);
    window.setTimeout(update, 80);
    window.setTimeout(update, 280);
    window.setTimeout(update, 700);
  }

  function setupSection(section) {
    var heading = section.querySelector('[data-cd-pdp-lineflow]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-cd-pdp-curtain-card]'));

    buildLineflow(heading);
    setupGalleryProgress(section);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          section.classList.add('is-visible');
          observer.disconnect();

          cards.forEach(function (card, index) {
            window.setTimeout(function () {
              card.classList.add('is-visible');
            }, index * 120);
          });
        }
      });
    }, {
      threshold: 0.22,
      rootMargin: '0px 0px -10% 0px'
    });

    observer.observe(section);
  }

  sections.forEach(setupSection);

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      sections.forEach(function (section) {
        var heading = section.querySelector('[data-cd-pdp-lineflow]');
        buildLineflow(heading);
      });
    }, 120);
  });
})();
